export default {
  translation: {
    common: {
      emailOrUsername: "E-mail ou nom d'utilisateur",
      invalidEmailOrUsername: "E-mail ou nom d'utilisateur invalide",
      invalidCredentials: 'Identifiants invalides',
      invalidPassword: 'Mot de passe invalide',
      logInToPlanka: 'Se connecter à Planka',
      noInternetConnection: 'Aucune connexion Internet',
      pageNotFound_title: 'Page non trouvée',
      password: 'Mot de passe',
      projectManagement: 'Gestion de projet',
      serverConnectionFailed: 'Échec de la connexion au serveur',
      unknownError: 'Erreur inconnue, réessayez plus tard',
      useSingleSignOn: "Utiliser l'authentification unique",
    },

    action: {
      logIn: 'Se connecter',
      logInWithSSO: "Se connecter avec l'authentification unique",
    },
  },
};
